var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_001-edit",
    "data-name": "001-edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.129,
    height: 22.048,
    viewBox: "0 0 22.129 22.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M20.729,51.2a.564.564,0,0,0-.559.568v5.044a1.693,1.693,0,0,1-1.678,1.7H2.8a1.693,1.693,0,0,1-1.678-1.7v-14.8a1.693,1.693,0,0,1,1.678-1.7H7.763a.568.568,0,0,0,0-1.136H2.8A2.822,2.822,0,0,0,0,42.012v14.8a2.822,2.822,0,0,0,2.8,2.84H18.492a2.822,2.822,0,0,0,2.8-2.84V51.772A.564.564,0,0,0,20.729,51.2Zm0,0",
    transform: "translate(0 -37.609)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M118.973.79a1.808,1.808,0,0,0-2.556,0L109.25,7.957a.4.4,0,0,0-.1.177l-.942,3.4a.4.4,0,0,0,.494.494l3.4-.943a.4.4,0,0,0,.177-.1l7.166-7.167a1.81,1.81,0,0,0,0-2.556Zm-8.848,7.428,5.865-5.865,1.892,1.892-5.865,5.865Zm-.378.758,1.511,1.511-2.09.579Zm9.129-5.726-.426.426-1.892-1.892.426-.426a1,1,0,0,1,1.42,0l.472.471A1.006,1.006,0,0,1,118.876,3.25Zm0,0",
    transform: "translate(-97.844 -0.261)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9b8236cee1eb3ef64c081bfa7b677d45.svg";
export { ForwardRef as ReactComponent };